import { render } from "./DamagesGallery.vue?vue&type=template&id=97f6c612"
import script from "./DamagesGallery.vue?vue&type=script&lang=js"
export * from "./DamagesGallery.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__